import Base from './base';

class TableResultsPerPage extends Base {
	start() {
		this.el.addEventListener('change', e => TableResultsPerPage.onChange(e));
	}

	static onChange(e) {
		const { target: { value } } = e;

		TableResultsPerPage.setPageSize(value);
	}

	static setPageSize(size) {
		const { location: { pathname, search } } = window;
		const searchParams = new URLSearchParams(search);

		searchParams.set('s', size);

		const searchString = searchParams.toString();

		window.location = `${pathname}?${searchString}`;
	}
}

export default TableResultsPerPage;

